import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppSelector } from '@/store/store-hooks'
import { selectActiveMatter, selectActiveMatterId } from '@/matter/store/selectors'
import { isUnassignedMatter } from '@/matter/utils/is-unassigned-matter'
import { Card } from '@/components/card/Card'
import AllSkillsDialog from '@/routes/dashboard/skills/components/AllSkillsDialog'
import { kFeatureFlags, kGetFeatureFlagStatus } from '@/constants/constants-feature-flags'
import { canCreateChat } from '@/matter/utils/matter-permissions'
import { kMyDriveName, matterPaths } from '@/routing/paths'

export function MatterOverviewActions() {
  const navigate = useNavigate()
  const activeMatterId = useAppSelector(selectActiveMatterId)
  const activeMatter = useAppSelector(selectActiveMatter)
  const [skillsDialogOpen, setSkillsDialogOpen] = useState(false)
  const newFilesUxEnabled = kGetFeatureFlagStatus(kFeatureFlags.NEW_FILES_UX)

  // This component is only rendered on matter overview, so activeMatterId should always exist
  if (!activeMatterId) {
    return null
  }

  const isUnassigned = isUnassignedMatter(activeMatter)

  const matterFilesHref = newFilesUxEnabled
    ? matterPaths.userFiles.root(activeMatterId)
    : isUnassigned
    ? matterPaths.files.drive(activeMatterId, kMyDriveName)
    : matterPaths.files.folder(activeMatterId, kMyDriveName, activeMatterId)

  return (
    <>
      <div className="mt-6 flex flex-col gap-6 sm:flex-row">
        {!isUnassigned && canCreateChat(activeMatter) && (
          <div className="min-w-0 flex-1">
            <Card description="Quick start your workflow" onClick={() => setSkillsDialogOpen(true)} title="Explore Skills" />
          </div>
        )}
        <div className="min-w-0 flex-1">
          <Card
            actionIcon="arrow-right"
            description="View and manage documents and files"
            onClick={() => navigate(matterFilesHref)}
            title="Manage Matter Files"
          />
        </div>
      </div>
      <AllSkillsDialog open={skillsDialogOpen} onOpenChange={setSkillsDialogOpen} />
    </>
  )
}
